import {API_SERVICE_URL} from "navigation-common/firebase-config";
import {AbstractApiService} from "../../api/AbstractApiService";

class BannerService extends AbstractApiService {
    public async shouldDisplayReviewBanner(): Promise<boolean> {
        const response = await this.client.get(API_SERVICE_URL + "/shouldDisplayReviewBanner", this.buildJWTAuthAxiosConfig());
        return response.data as boolean;
    }

    public async hideReviewBanner(): Promise<boolean> {
        const response = await this.client.post(API_SERVICE_URL + "/hideReviewBanner", {}, this.buildJWTAuthAxiosConfig());
        return response.data;
    }
}

export const bannerService = new BannerService();
